<template>
  <div class="projectManagePage">
    <!-- 弹框 -->
    <div class="functions">
      <div class="programName">
        <div class="programName1" style="width:160px">项目管理</div>
      </div>
      <div class="functions1">
        <div>请选择云服务：</div>
        <div class="cloudSelect" style="width:25%;margin-right:20px">
          <el-select v-model="value" placeholder="请选择云服务" @change="cloudChange" style="" clearable filterable>
            <el-option
              v-for="item in clouds"
              :key="item.id"
              :label="item.cloudName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div>项目名：</div>
        <div class="programInput" style="width:25%">
          <el-input v-model="search_name" placeholder="请输入项目名" class="search_input" suffix-icon="el-icon-search" clearable @keydown.enter.native="handle_name_change" />
        </div>
        <div class="add_btn" style="margin-left:20px">
          <el-button type="primary" @click="addProject" round>+ 新增</el-button>
        </div>
        <el-dialog title="新增项目" :visible.sync="dialogFormVisible1" :before-close="beforeClose" v-if="dialogFormVisible1" :close-on-click-modal="false">
          <el-form
            :model="projectForm"
            ref="subProjectForm"
            :rules="projectFormValidate"
             :label-width="formLabelWidth"
          >
            <el-form-item label="项目名称：" prop="projectName">
              <el-input
                v-model="projectForm.projectName"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人：" prop="contactName">
              <el-input
                v-model="projectForm.contactName"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="mobile">
              <el-input
                v-model="projectForm.mobile"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="核心系统id：" prop="coreSystemId" v-if="cloudConfigId === 1">
              <el-input
                v-model="projectForm.coreSystemId"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="核心系统IP：" prop="coreSystemIp" v-if="cloudConfigId === 1">
              <el-input
                v-model="projectForm.coreSystemIp"
                autocomplete="off"
                placeholder="请以http或者https开头"
              ></el-input>
            </el-form-item>
            <el-form-item label="省市：" prop="provinceCities">
              <el-cascader
                v-model="cascaderValue"
                placeholder="请选择省市"
                :options="provinceCitiesOptions"
                @change="selectCity"
                filterable>
              </el-cascader>
            </el-form-item>
            <el-form-item label="详细地址：">
              <el-input
                v-model="projectForm.address"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="代理商：">
              <div class="select">
                <el-select v-model="projectForm.companyName" placeholder="请选择代理商" @change="agentChange" style="width:100%" clearable filterable>
                  <el-option
                    v-for="(item,index) in companyNames"
                    :key="index"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>             
            </el-form-item>
            <el-form-item label="协议类型：" prop="protocolType">
              <div class="select">
                <el-select v-model="projectForm.protocolType" placeholder="请选择协议类型" @change="protocolTypeChange" style="width:100%" clearable filterable>
                  <el-option
                    v-for="(item,index) in protocolType"
                    :key="index"
                    :label="item.value"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>             
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="info" @click="cancelClick('subProjectForm')">取 消</el-button>
            <el-button type="primary" @click="confirmClick('subProjectForm')" class="submit" :loading="loadingsubmit">{{confirmText}}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- 表格 -->
    <div class="tableInfo">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%" :header-cell-style="{color: '#333'}"
       element-loading-background = "rgba(255, 255, 255, .5)" element-loading-text = "加载中，请稍后..." element-loading-spinner = "el-icon-loading">
        <el-table-column prop="projectName" label="项目名称" min-width="150" fixed="left">
        </el-table-column>
        <el-table-column prop="company.companyName" label="代理商名称" min-width="120">
        </el-table-column>
        <el-table-column prop="contactName" label="联系人" min-width="100">
        </el-table-column>
        <el-table-column prop="mobile" label="联系方式" width="150">
        </el-table-column>
        <el-table-column prop="province_city" label="省市" min-width="150">
        </el-table-column>
        <el-table-column prop="address" label="详细地址" min-width="150">
        </el-table-column>
        <el-table-column prop="protocolTypestr" label="协议类型" width="100">
        </el-table-column>
        <el-table-column prop="hotelUuid" label="酒店id" width="100" v-if="cloudConfigId===2">
        </el-table-column>
        <el-table-column prop="createUserName" label="创建者" min-width="100">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="timestampToTime" width="180">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="{row}">
            <el-button @click="editProject(row)" type="text" size="small" class="edit">修改</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button @click="deleteProject(row)" type="text" size="small" class="delete">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 修改项目信息 -->
      <el-dialog title="修改项目" :visible.sync="dialogFormVisible2" :before-close="beforeClose" v-if="dialogFormVisible2" :close-on-click-modal="false">
        <el-form
          :model="projectForm"
          ref="subProjectForm"
          :rules="projectFormValidate"
           :label-width="formLabelWidth"
        >
          <el-form-item label="项目名称：" prop="projectName">
            <el-input
              v-model="projectForm.projectName"
              autocomplete="off"             
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人：" prop="contactName">
            <el-input
              v-model="projectForm.contactName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="mobile">
            <el-input
              v-model="projectForm.mobile"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="核心系统id：" prop="coreSystemId" v-if="cloudConfigId === 1">
            <!-- projectForm.coreSystemId !== undefined &&  -->
            <el-input
              v-model="projectForm.coreSystemId"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="核心系统IP：" prop="coreSystemIp" v-if="cloudConfigId === 1">
           <!-- projectForm.coreSystemIp !== undefined &&  -->
            <el-input
              v-model="projectForm.coreSystemIp"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="省市：" prop="provinceCities">
            <el-cascader
              v-model="cascaderValue"
              placeholder="请选择省市"
              :options="provinceCitiesOptions"
              @change="selectCity"
              filterable>
            </el-cascader>
          </el-form-item>
          <el-form-item label="详细地址：" prop="address">
            <el-input
              v-model="projectForm.address"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- 不修改代理商 -->
          <!-- <el-form-item label="代理商：">
            <div class="select">
              <el-select v-model="projectForm.companyName" placeholder="请选择代理商" @change="agentChange" disabled>
                <el-option
                  v-for="(item,index) in companyNames"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>             
          </el-form-item> -->
          <el-form-item label="协议类型：" prop="protocolType">
              <div class="select">
                <el-select v-model="projectForm.protocolType" placeholder="请选择协议类型" @change="protocolTypeChange" style="width:100%" clearable filterable>
                  <el-option
                    v-for="(item,index) in protocolType"
                    :key="index"
                    :label="item.value"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>             
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="info" @click="cancelClick('subProjectForm')">取 消</el-button>
          <el-button type="primary" @click="confirmClick('subProjectForm')" class="submit" :loading="loadingsubmit">{{confirmText}}</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        background
        @size-change="changeSize"
        @current-change="changePage"
        :current-page="page.pageNum"
        :page-sizes="page_size_list"
        :page-size="page.pageSize"
        layout="prev, pager, next, sizes, total, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Utils from '../../../js/utils' 
import {mapState} from "vuex"
//引入projectInfo
import { projectInfo, viewProjectInfo,cloudCompany } from "@/api";
// import {cancel} from "@/api"
//新增项目
import { addProjectInfo, cloudSelectInfo, editProjectInfo,delProjectInfo,getProvinceCities,viewAuthorizedProjects } from "@/api";
const api = require("@/api");
export default {
  data() {
    // 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/
      if (!value) {
        return callback(new Error('电话号码不能为空'))
      }
      setTimeout(() => {  
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (phoneReg.test(value)) {
            callback()
          } else {
            callback(new Error('电话号码格式不正确'))
          }
        }
      }, 100)
    };
    return {
      search_name: '',
      loading: false,
      loadingsubmit: false,
      confirmText: '确定',
      //下拉选择值
      value: '',
      //选择的云管理
      clouds: [],
      cloudConfigId: '',//选择的云id
      companyNames: [],//代理商名称
      //dialog
      apiName: "",
      successMsg: "",
      errorMsg: "",
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      projectForm: {
        projectName: "",
        contactName: "",
        coreSystemId: "",
        coreSystemIp: "",
        regionProvince: '',
        regionCity: '',
        cloudConfigId: "",
        companyName: '',
        id: null,
        address: '',
        protocolType: null,
        mobile: null
      },
      id: null,
      projectFormValidate: {
        projectName: [
          {required: true, message: "请输入项目名称", trigger: "blur",},
          {
            validator: function(rule, value, callback) {
              if (/^[A-Za-z0-9-_\u4e00-\u9fa5]{2,30}$/.test(value) == false) {
                callback(new Error("请输入正确的项目名称"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        contactName: [
          {required: true, message: "请输入联系人", trigger: "blur",},
          {
            validator: function(rule, value, callback) {
              if (/^[A-Za-z0-9-_\u4e00-\u9fa5]{2,30}$/.test(value) == false) {
                callback(new Error("请输入正确的联系人名称"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        protocolType: [
          {
            required: true,
            message: "请选择协议类型",
            trigger: "change",
          },
        ],
        mobile: [
          { required: true, validator: checkPhone, trigger: "blur",},//'blur'是鼠标失去焦点的时候会触发验证
        ],
      },
      provinceCitiesOptions: [],
      cascaderValue: [],
      formLabelWidth: "110px",
      //table
      tableData: [],
      //分页参数
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      page_size_list: [10,15,20],
      timer: null,
      protocolType:[
        {id: 1,value: "有线"},
        {id: 2,value: "无线"},
        // {id: 3,value: "有线+无线"}
      ],
      source: null
    };
  },
  computed:{
    //映射
    ...mapState(['cloudId']),
  },
  methods: {
    handle_name_change() {
      this.updateProjectTable(this.cloudConfigId,this.page)
    },
    //时间戳
    timestampToTime (row, column) {
      var date = new Date(row.createTime) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
      var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' '
      var h = (date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ':'
      var s = date.getSeconds() < 10 ? '0'+(date.getSeconds()) : date.getSeconds() 
      return Y+M+D+h+m+s
    },

    //修改项目
    editProject(row) {
      this.cascaderValue = []
      //弹出dailog
      this.dialogFormVisible2 = true;
      console.log(row);
      //数据回显
      this.projectForm = { ...row };
      this.cascaderValue.push(row.regionProvince)
      this.cascaderValue.push(row.regionCity)
      console.log(this.projectForm);
      //更改提交
      this.apiName = "editProjectInfo";
      this.successMsg = "修改成功";
      this.errorMsg = "修改失败";
      // this.$refs['subProjectForm'].clearValidate(); // 仅清除验证
    },

    //删除表格数据
    deleteProject(row){
      if (row && row.id) {
        //提示信息是否永久删除
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //调用删除请求
          let id = row.id
          let cloudId = this.cloudConfigId
          delProjectInfo(cloudId,id)
          .then((res) => {
            if (res.data.code == '0') {
              this.$message.success("删除成功");
              //更新表格
              this.updateProjectTable(this.cloudConfigId,this.page);
            } else {
              this.$message.warning("删除失败");
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error("删除出错");
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });  
      }else{
        this.$message.error("没有row数据")
        return
      }
    },

    beforeClose(){
      this.dialogFormVisible1 = false;
      this.dialogFormVisible2 = false;
    },

    cancelClick(formName){
      this.dialogFormVisible1 = false;
      this.dialogFormVisible2 = false;
    },

    //增加信息
    addProject() {
      //清空表单数据
      Object.keys(this.projectForm).forEach(
        (key) => (this.projectForm[key] = "")
      );
      this.projectForm = {}
      this.cascaderValue = []
      this.dialogFormVisible1 = true;
      this.apiName = "addProjectInfo";
      this.successMsg = "添加成功";
      this.errorMsg = "添加失败";
      if(this.$refs['subProjectForm'] !== undefined){
        this.$refs['subProjectForm'].resetFields();
      }
    },
    //取消请求
    cancelQuest() {
      if (typeof this.source === 'function') {
        this.source('终止请求'); //取消请求
      }
    },
    // 更新表格数据
    updateProjectTable(id,pageList) {
      let cloudConfigId = id
      if(cloudConfigId){
        let cloud_name = ""
        for(let i = 0; i < this.clouds.length; i++){
          if(id == this.clouds[i].id){
            cloud_name = this.clouds[i].cloudName
          }
        }
        this.loading = true
        projectInfo(cloudConfigId,pageList,this,this.search_name).then((res) => {
          console.log("表格数据",res,);
          if (res.data.code == '0') {
            this.tableData = res.data.data;
            this.tableData.forEach(item=>{
              item.province_city = item.regionProvince+item.regionCity
              if(item.protocolType === 1){
                item.protocolTypestr = "有线"
              }else if(item.protocolType === 2){
                item.protocolTypestr = "无线"
              }
              // else if(item.protocolType === 3){
              //   item.protocolTypestr = "有线+无线"
              // }
            })
            this.total = res.data.count;
          }
          this.loading = false
        }).catch((err) => {
          console.log(err,cloud_name+"项目表格数据获取失败");
          this.$message.error(cloud_name+"项目表格数据获取失败");
          this.loading = false
        }); 
      }else{
        this.tableData = []
        this.total = 0
      }
      
      //  setTimeout(function () {
      //   //只要我们去调用了这个cancel()方法，没有完成请求的接口便会停止请求
      //   cancel()
      // }, 100) 
    },

    //dailog对话框
    confirmClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadingsubmit = true
          this.confirmText = "提交中..."
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          //本地表单校验通过，将表单信息提交到后台
          this.projectForm.cloudConfigId=this.cloudConfigId
          let form = {
            projectName : this.projectForm.projectName,
            contactName : this.projectForm.contactName,
            coreSystemId : this.projectForm.coreSystemId,
            coreSystemIp : this.projectForm.coreSystemIp,
            regionProvince : this.projectForm.regionProvince,
            regionCity : this.projectForm.regionCity,
            cloudConfigId : this.projectForm.cloudConfigId,
            companyName : this.projectForm.companyName,
            id : this.projectForm.id,
            address : this.projectForm.address,
            protocolType: this.projectForm.protocolType,
            mobile: this.projectForm.mobile
          }
          api[this.apiName](form)
            .then((res) => {
              if (res.data.code == '0') {
                //关闭dailog
                this.dialogFormVisible1 = false;
                this.dialogFormVisible2 = false;
                //提示添加成功，更新表格数据
                this.$message.success(this.successMsg);
                this.updateProjectTable(this.cloudConfigId,this.page);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(err.message);
            })
            .finally(()=>{
              this.loadingsubmit = false
              this.confirmText = "确定"
              loading.close();
            })
        } else {
          this.confirmText = "确定"
          this.$message.error("表单校验不通过");
        }
      });
    },

    //改变分页
    changePage(e) {
      this.page.pageNum = e;
      //更新表格数据
      this.updateProjectTable(this.cloudConfigId,this.page)
    },
    changeSize(val){
      this.page.pageSize = val;
      //更新表格数据
      this.updateProjectTable(this.cloudConfigId,this.page)
    },
    //下拉框列表数据
    cloudSelect(){
      cloudSelectInfo().then((res) => {
        console.log('云服务列表',res,);
        if(res.data.code == 0){
          this.clouds = res.data.data;
          this.value = this.clouds[0].id
          this.cloudConfigId = this.clouds[0].id
          this.updateProjectTable(this.cloudConfigId,this.page)
          this.getCompanyNames(this.cloudConfigId)
          res.data.data.forEach(cloud=>{
            // console.log(cloud);
          })
        }else{
          this.$message.warning(err.data.message)
        }
      })
      .catch((err=>{
        console.log('下拉云管理列表数据获取失败',err);
        this.$message.error("下拉云管理列表数据获取失败")
      }))
    },

    //下拉选择信息
    cloudChange(event){
      this.cloudConfigId = event
      // this.value = event
      console.log(this.cloudConfigId,this.value,"云管理id");
      //更新表格数据
      this.updateProjectTable(this.cloudConfigId,this.page)
      // this.$nextTick(this.updateProjectTable(this.cloudConfigId,this.page))
      //云管理对应的代理商
      this.getCompanyNames(this.cloudConfigId)
    },

    //获得省市数据
    getProvinceCities(){
      getProvinceCities()
      .then(res=>{
        console.log(res,"获得省市");
        this.provinceCitiesOptions = res.data.data
      })
      .catch((err=>{
        console.log(err);
        this.$message.error(err.data.message)
      }))
    },

    //选择城市
    selectCity(value){
      console.log(value,"选择城市");
      this.projectForm.regionProvince = value[0]
      this.projectForm.regionCity = value[1]
    },

    //代理商所有名称
    getCompanyNames(cloudConfigId){
      this.companyNames = []
      let id = cloudConfigId 
      cloudCompany(id)
      .then(res=>{
        console.log(res,"获得所有的代理商");
        res.data.data.forEach(item=>{
          this.companyNames.push(item.companyName)
        })
      })
    },

    //选择代理商
    agentChange(value){
      console.log(value,"选择代理商");
      this.projectForm.companyName = value
    },

    //选择协议
    protocolTypeChange(event){
      console.log(event,"选择协议");
    }
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },
  // created(){
  //   var that = this;
  //   Utils.$on('demo',function(cloudId,page) {
  //     console.log(cloudId);
  //     that.updateProjectTable(cloudId,page);
  //   })
  // },
  mounted() {
    // console.log(this.cloudId);
    // this.timer = setTimeout(()=>{
    //   this.updateProjectTable(this.cloudId,this.page)
    // },100)
    //下拉选择信息
    this.cloudSelect();
    //获得省市数据
    this.getProvinceCities()
    
  },
};
</script>

<style scoped>
.projectManagePage {
  width: 100%;
  height: 100%;
  font-family: PingFang SC;
}
.functions {
  width: 100%;
  height: 80px;
  border-radius: 10px 10px 0 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-sizing: border-box;
  font-weight: 549;
  font-size: 16px;
}
.programName{
  /* width: 40%; */
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}    
.functions1{
  height: 100%;
  display: flex;
  align-items: center;
  width: 60%;
  justify-content: flex-end;
}
.functions1 .el-button.is-round{
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #455AF7;
  border-radius: 5px;
}
.programInput, .cloudSelect{
}
.tableInfo{
  width: 100%;
  padding: 0 20px 20px 20px;
  box-sizing: border-box;
  background: #fff;
}
.tableInfo >>> .el-table td,
.tableInfo >>> .el-table th {
  text-align: center !important;
}
.tableInfo >>> .el-button--small, .el-button--small.is-round{
    padding: 3px 3px;
}
.tableInfo >>> th{
  background: #F2F3F7;
}

/* 上传logo边框未设置 */
/* 弹出框 */
.submit{
  background: #455AF7;
  border-color: #455AF7;
}
.projectManagePage >>> .el-dialog{
  width: 40%;
  background:  #F2F3F7;
}
.projectManagePage >>> .el-dialog__header{
  display: flex;
  justify-content: center;
  font-weight: 549;
  background: #fff;
  
}
.projectManagePage >>> .el-dialog__body{
  padding: 15px 15px 0 15px!important;
}
.el-form{
  background: #fff;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.projectManagePage >>> .el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #455AF7!important;
}
.projectManagePage >>> .el-dialog__footer{
  padding: 0 15px 15px 15px!important;
  
}
.el-form-item{
  width: 85%;
}
.projectManagePage >>> .el-select{
  width: 100%;
}
.projectManagePage >>> .el-cascader{
  width: 100%;
}
.projectManagePage >>> .el-form-item__content{
  margin-left: 80px;
}
.dialog-footer{
  background: #fff;
  padding: 10px ;
}
/* select */
.select .el-input {
  width: 100%;
}
.delete{
  color: #FB3F4E;
}
/* 分页 */
.pagination {
  width: 100%;
  height: 80px;
  background: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 20px;
  box-sizing: border-box;
}
.edit{
  color: #455AF7!important;
}
.delete{
  color: #FB3F4E!important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Home/projectManagement/index.vue